module.exports = __webpack_public_path__ + "static/media/profile-picture-3.fc11ae54.png";